import React, { useState } from 'react';

import { FILTER_RELATIONS } from '../../../CommunityDashboard/helpers/constants';

import AppBar from '../../../../base/components/AppBar/AppBar';
import TotalSampleSize from './components/TotalSampleSize/TotalSampleSize';
import Filters from '../../../CommunityDashboard/components/CommunityDashboardPage/components/Filters/Filters';
import MainPageCharts from './components/MainPageCharts/MainPageCharts';

import styles from './FeasibilityCheckerPage.module.css';

export default props => {
  const { isAdmin } = props;
  const [appliedFilters, setAppliedFilters] = useState([
    {
      type: 'USER_PROPERTY',
      userProperties: {
        propertyName: 'LANGUAGE',
        propertyValue: ['Dutch']
      }
    }
  ]);
  const [filterRelation, setFilterRelation] = useState(FILTER_RELATIONS.AND);
  const [isGlobalLoading, setIsGlobalLoading] = useState(false);
  const [totalSampleSize, setTotalSampleSize] = useState(300);
  const [totalSampleSizeLoading, setTotalSampleSizeLoading] = useState(false);

  if (!isAdmin) return null;

  return (
    <div>
      <AppBar {...props} />
      <div className={styles.container}>
        <div className={styles.title}>Feasibility checker</div>
        <TotalSampleSize
          totalSampleSize={totalSampleSize}
          setTotalSampleSize={setTotalSampleSize}
          setTotalSampleSizeLoading={setTotalSampleSizeLoading}
        />
        <Filters
          appliedFilters={appliedFilters}
          setAppliedFilters={setAppliedFilters}
          filterRelation={filterRelation}
          setFilterRelation={setFilterRelation}
          isGlobalLoading={isGlobalLoading}
          allowSetQuota
          isFeasibilityChecker
        />
        <MainPageCharts
          appliedFilters={appliedFilters}
          filterRelation={filterRelation}
          isGlobalLoading={isGlobalLoading}
          setIsGlobalLoading={setIsGlobalLoading}
          totalSampleSize={totalSampleSize}
          totalSampleSizeLoading={totalSampleSizeLoading}
        />
      </div>
    </div>
  );
};
